import { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import NavigationBar from '../components/navigationBar';
import Sidebar from '../components/sidebar';
import BottomNav from '../components/bottomNav';
import AskSoroby from '../components/askSoroby/askSoroby';
import { getCurrentUser } from '../services/auth';
import useCompanyMessaging from '../hooks/useCompanyMessaging';
import './dashboard.css';

const Shell = ({ currentUser, sidebarToggle, setSidebarToggle }) => {
    // Loads the company's phone dial code once per session so every
    // WhatsApp / Viber link on any page dials the full international number.
    useCompanyMessaging()

    return (
        <div className="container-fluid">
            <div className="row">

                <Sidebar sidebarToggle={sidebarToggle} setSidebarToggle={setSidebarToggle} currentUser={currentUser} />

                <main role="main" className="col-md-9 pb-5 ms-sm-auto col-lg-10 px-0 sb-main">

                    <NavigationBar setSidebarToggle={setSidebarToggle} currentUser={currentUser} />

                    <div className="content pt-3 px-4">

                        <Outlet />

                    </div>
                </main>
            </div>

            <AskSoroby currentUser={currentUser} />

            <BottomNav />
        </div>
    )
}

const DashboardTemplate = () => {

    const [sidebarToggle, setSidebarToggle] = useState(false)

    const _currentUser = getCurrentUser()

    if (!_currentUser) return <Navigate to="/login" />
    if (_currentUser.isPlatformOwner && !_currentUser.activeCompanyId) return <Navigate to="/platform" />

    return (
        <Shell currentUser={_currentUser} sidebarToggle={sidebarToggle} setSidebarToggle={setSidebarToggle} />
    )
}

export default DashboardTemplate;

